import {AppMenuItem} from '../../shared/interfaces/menu-config-interface';
import {TipoPuntoVentaEnum} from '../../shared/enums/tipo-punto-venta-enum';
import {AmbienteEnum} from '../../shared/enums/ambiente-enum';
import {SociedadEnum} from '../../shared/enums/sociedad-enum';
import {MENU_PERMISSIONS} from '../constants/menu-permissions.constant';

export const PROMOCIONES_MENU: AppMenuItem = {
  "children": [
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion,
        AmbienteEnum.Produccion
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.MX
      ],
      "children": [
        {
          "breadcrumb": true,
          "label": "Editar Promoción",
          "route": "promociones/editar",
          "visible": false
        },
        {
          "breadcrumb": true,
          "label": "Agregar Promoción",
          "route": "promociones/agregar",
          "visible": false
        },
        {
          "breadcrumb": true,
          "label": "Ver Promoción",
          "route": "promociones/ver",
          "visible": false
        }
      ],
      "label": "XXY PT",
      "route": "promociones/promocion-xxy",
      "proceso": MENU_PERMISSIONS.promocionXXYPT,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo,
        TipoPuntoVentaEnum.PuntoVentaPropio,
        TipoPuntoVentaEnum.Franquicias
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion,
        AmbienteEnum.Produccion
      ],
      "sociedades": [
        SociedadEnum.SC,
        SociedadEnum.MX
      ],
      "children": [
        {
          "breadcrumb": true,
          "label": "Editar Promoción PS",
          "route": "promociones/promocion-semiterminados-xxy/editar",
          "visible": false
        },
        {
          "breadcrumb": true,
          "label": "Agregar Promoción PS",
          "route": "promociones/promocion-semiterminados-xxy/agregar",
          "visible": false
        }
      ],
      "label": "XXY PS",
      "route": "promociones/promocion-semiterminados-xxy",
      "proceso": MENU_PERMISSIONS.promocionXXYSM,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo,
        TipoPuntoVentaEnum.PuntoVentaPropio,
        TipoPuntoVentaEnum.Franquicias
      ],
      "visible": true
    },
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion,
        AmbienteEnum.Produccion
      ],
      "sociedades": [
        SociedadEnum.SC
      ],
      "children": [
        {
          "breadcrumb": true,
          "label": "Editar Promoción CP",
          "route": "promociones/promocionales/editar",
          "visible": false
        },
        {
          "breadcrumb": true,
          "label": "Agregar Promoción CP",
          "route": "promociones/promocionales/agregar",
          "visible": false
        }
      ],
      "label": "Clientes Promocionales",
      "route": "promociones/promocionales",
      "proceso": MENU_PERMISSIONS.promocionPromocionales,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo,
        TipoPuntoVentaEnum.PuntoVentaPropio,
        TipoPuntoVentaEnum.Franquicias
      ],
      "visible": true
    },
    {
      "label": "Cupones",
      "route": "promociones/promocion-cupones",
      "proceso": MENU_PERMISSIONS.promocionCupones,
      "visible": true,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo,
        TipoPuntoVentaEnum.PuntoVentaPropio,
        TipoPuntoVentaEnum.Franquicias
      ],
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC
      ]
    },
    {
      "label": "Alianzas",
      "route": "promociones/promociones-alianzas",
      "proceso": MENU_PERMISSIONS.promocionCupones,
      "visible": true,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo,
        TipoPuntoVentaEnum.PuntoVentaPropio,
        TipoPuntoVentaEnum.Franquicias
      ],
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad
      ],
      "sociedades": [
        SociedadEnum.SC
      ]
    }
  ],
  "label": "Promociones",
  "visible": true
};
